import { render } from "./ContextSubMenu.vue?vue&type=template&id=59f807de&ts=true"
import script from "./ContextSubMenu.vue?vue&type=script&lang=ts"
export * from "./ContextSubMenu.vue?vue&type=script&lang=ts"

import "./ContextSubMenu.vue?vue&type=style&index=0&id=59f807de&lang=css"

import exportComponent from "D:\\Code\\GitHub\\vue3-context-menu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__